/**
 * Entrypoint for all the js scripts enqueued in the admin
 */
import AdminSettings from './admin/js/settings/admin-settings';
import MetaBox from './admin/js/meta-box/meta-box';
import Toolbar from "./admin/js/toolbar";

window.addEventListener('load', () => {
    AdminSettings.bindEvents();
    MetaBox.bindEvents();
});

wp.domReady(() => {
    // Block editor
    Toolbar.register();
});